
import React, { useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './AuthProvider';
import { ProfilePage } from './components/ProfilePage';
import { useGeneralSettings } from './hooks/useQueries';
import { useDynamicGTM } from './hooks/useDynamicGTM';
import { AiHeavyJobProvider } from './context/AiHeavyJobContext';
import { AiGlobalFloatingWidget } from './components/questions/AiGlobalFloatingWidget';
import { AiGenerateQuestionsModal } from './components/questions/AiGenerateQuestionsModal';

const GOOGLE_CLIENT_ID = "313208471377-9sb5rjv1ceh9f48a32lirji1sapqgd1s.apps.googleusercontent.com";

const AppContent: React.FC = () => {
  // Tích hợp Google Tag Manager (GTM) động từ api GET /api/home_configs/general_settings
  useDynamicGTM();

  // Lấy favicon cho hệ thống từ React Query cache (useGeneralSettings) - dùng chung với các component khác
  const { data: generalSettingsData } = useGeneralSettings();

  useEffect(() => {
    const faviconUrl = generalSettingsData?.data?.faviconUrl || generalSettingsData?.faviconUrl;
    if (faviconUrl && typeof document !== 'undefined') {
      const linkElements = document.querySelectorAll("link[rel*='icon']");
      if (linkElements.length > 0) {
        linkElements.forEach((linkEl) => {
          (linkEl as HTMLLinkElement).href = faviconUrl;
        });
      } else {
        const newLink = document.createElement('link');
        newLink.rel = 'shortcut icon';
        newLink.href = faviconUrl;
        document.getElementsByTagName('head')[0].appendChild(newLink);
      }
    }
  }, [generalSettingsData]);

  return (
    <div className="bg-background text-slate-900 min-h-screen relative">
      <ProfilePage />
      <AiGlobalFloatingWidget />
      <AiGenerateQuestionsModal />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <AiHeavyJobProvider>
          <AppContent />
          <Toaster position="top-center" />
        </AiHeavyJobProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
};

export default App;

